import { Component } from '@angular/core';
import { RidButton } from '../../../components';
import { RidDemoPage } from '../../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-formule-page',
  imports: [RidButton, RidDemoPage],
  templateUrl: './formule-page.html',
})
export class FormulePage {}
